import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import NotificationIconSolid from '@/components/icons/NotificationIconSolid';
import NotificationSnoozeIconSolid from '@/components/icons/NotificationSnoozeIconSolid';

type Props = { type: boolean };

const NotificationsTypeDetails: FC<Props> = ({ type }) => {
	const { t } = useTranslation();

	const status = type
		? [
				'main.notifications.type.required',
				<NotificationIconSolid className={'fill-status-suspended'} />,
		  ]
		: [
				'main.notifications.type.optional',
				<NotificationSnoozeIconSolid
					className={'fill-status-active'}
				/>,
		  ];

	const [name, icon] = status;

	return (
		<div className='flex items-center gap-1.5'>
			{icon}
			<label
				className={`text-sm ${
					name !== 'Unknown'
						? 'text-popover-800'
						: 'text-status-suspended'
				}`}>
				{t(name as string)}
			</label>
		</div>
	);
};

export default NotificationsTypeDetails;
